import {z as r, z} from 'zod';

import {ReviewConcordanceRequestType} from '../review-concordance/review-concordance-type';

export enum ConcordanceAiPresetEnum {
    SWOT = 'SWOT',
    NEGATIVE_EXPERIENCE = 'NEGATIVE_EXPERIENCE',
    POSITIVE_EXPERIENCE = 'POSITIVE_EXPERIENCE',
    CLIENT_REQUESTS = 'CLIENT_REQUESTS',
    NEGATIVE_REVIEWS_THEMES = 'NEGATIVE_REVIEWS_THEMES',
    POSITIVE_REVIEWS_THEMES = 'POSITIVE_REVIEWS_THEMES',
    EMOTIONAL_TONE_OF_REVIEWS = 'EMOTIONAL_TONE_OF_REVIEWS',
    STAFF_MENTIONS_AND_FEEDBACK = 'STAFF_MENTIONS_AND_FEEDBACK',
}

export enum AiChatMessageRoleEnum {
    USER = 'user',
    ASSISTANT = 'assistant',
    SYSTEM = 'system',
}

const reviewAnalysisAiMessageSchema = z.object({
    role: z.nativeEnum(AiChatMessageRoleEnum),
    title: z.string().optional(),
    text: z.string(),
    preset: z.nativeEnum(ConcordanceAiPresetEnum).optional(),
});

export type ReviewAnalysisAiMessageType = z.infer<typeof reviewAnalysisAiMessageSchema>;

export type AiMessagePayloadType = {
    searchParams: Omit<ReviewConcordanceRequestType, 'page' | 'pageSize' | 'contextSize'>;
    channelId: string;
    requestId: string;
    filterKey: string;

    message: string;
    presetKey?: ConcordanceAiPresetEnum;
};

const reviewAiAnalysisSuggestsSchema = r.object({
    error: r.string().nullable(),
    requestId: r.string(),
    stop: r.boolean(),
    text: r.string(),
});

type ReviewAiSuggestType = r.infer<typeof reviewAiAnalysisSuggestsSchema>;

export function isReviewAnalysisSuggestAction(data: unknown): data is ReviewAiSuggestType {
    return reviewAiAnalysisSuggestsSchema.safeParse(data).success;
}
